import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useContext } from "react";
import { queryClient } from "../../api/requestProcessor";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "../../context/AppProvider";
import { getErrorMessage } from "../../util/helper";
import { deletePunchList } from "../../api/punchListsAPI";

export default function DeletePunchListDialog({
  isVisible,
  hideDialog,
  punchListId,
}) {
  const { toast } = useContext(AppContext);

  const { mutate: deletePunchListMutation, isPending: isPendingDeletion } =
    useMutation({
      mutationFn: deletePunchList,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["punch-lists"] });
        hideDialog();
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Punch List Deleted",
          life: 3000,
        });
      },
      onError: (error) => {
        toast.current.show({
          severity: "Error",
          summary: "Error",
          detail: getErrorMessage(error),
          life: 3000,
        });
      },
    });

  const handleUpdatePunchList = () => {
    deletePunchListMutation(punchListId);
  };

  const dialogFooter = (
    <>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label={isPendingDeletion ? "Deleting" : "Delete"}
        icon="pi pi-trash"
        onClick={handleUpdatePunchList}
        loading={isPendingDeletion}
        severity="danger"
      />
    </>
  );

  return (
    <Dialog
      visible={isVisible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header="Delete Punch List Item"
      modal
      className="p-fluid mx-2"
      footer={dialogFooter}
      onHide={hideDialog}
    >
      <div className="field">
        <label htmlFor="title" className="font-bold">
          Are you sure to delete the punch list?
        </label>
      </div>
    </Dialog>
  );
}
